const {
  getEmptyTableMessage,
  getEmptyTableOnSearchMessage,
} = require('./utils')

module.exports = {
  employees: 'Employees',
  addEmployee: 'Add Employee',
  acronym: 'Acronym',
  details: '@:common.details',
  roles: '@:common.roles',
  color: '@:common.color',
  onlineReg: 'Online reg.',
  fullName: '@:common.fullName',
  name: '@:common.firstName',
  email: '@:common.email',
  surname: '@:common.surname',
  phoneNumber: '@:common.phoneNumber',
  practiceBranch: 'Practice branch',
  preferredRooms: 'Preferred rooms',
  selectPracticeBranch: 'Select branch',
  workingTime: 'Working time',
  all: 'All',
  searchPlaceholder: 'Type to search',
  invitationTitle:
    "You've been invited to join <span class='text-primary'>{practiceName}</span>",
  invitationEmailWarning: `
    Invitation was sent to <b>{invitedEmail}</b> and you're logged in
    with <b>{actualEmail}</b
    >. If that wasn't intentional, please click
    <b>"Decline and Logout"</b> button and login with the correct
    account.
  `,
  acceptInvitation: 'Accept invitation',
  declineInvitation: 'Decline and Logout',
  rolesEnum: {
    adm: 'Admin | Admins',
    rec: 'Reception',
    emp: 'Employee | Employees',
    tech: 'Technical staff',
    fin: 'Financial',
  },
  editAvailability: 'Edit availability',
  table: {
    empty: getEmptyTableMessage('employees', 'Add Employee'),
    emptyOnSearch: getEmptyTableOnSearchMessage('employees'),
  },
  tooltips: {
    clickAvailability: 'Click to set availability',
    editEmployee: 'Edit employee',
    resendInvitation: 'Resend Invitation',
    accountConfirmed: 'Account has been confirmed',
    clickToRemoveEmployee: 'Click to remove employee',
  },
  form: {
    selectPreferredRooms: 'Select preferred rooms',
    selectPracticeBranchFirst: 'Select practice branch first',
    selectRoles: 'Select roles',
    confirmDeleteEmployee: 'Do you want to delete this employee?',
  },
  availableInOnlineRegistration: {
    title: 'This person is available for online booking',
    description:
      "If you don't check this, patients won't be able to schedule appointments with this person",
  },
  clickToDeleteThisPerson: {
    title: 'Click to delete this person',
    description:
      'The deleted person will no longer have access to your data and your center',
  },
}
